import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ModalPopup from '@ui/components/VnModal';
import { useEffect, useState } from 'react';
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import AddQuotationForm from './addQuotationForm';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllQuotationStatusAsync, getAllQuotationsAsync } from '@application/features/quotations/quotationThunk';
import QuotationsTable from './quotationsTable';
import VnPagination from '@ui/components/VnPagination';
import { useNavigate } from 'react-router-dom';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
export default function Quotation() {
    VnDocumentTitle('Visser Offertes');
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useAppDispatch();
    const [searchQuotation, setSearchQuotation] = useState(true);
    const navigate = useNavigate();
    const [currentSortColumnKey, setCurrentSortColumnKey] = useState('');
    const [currentSortDirection, setCurrentSortDirection] = useState('');
    const [copiedFilterValues, setCopiedFilterValues] = useState();
    const defaultQuotationFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: 'created',
        sortDirection: 'desc',
        quotationNumber: null,
        statusId: null,
        dateSent: null,
        created: null,
        // createdBy: null,
        workorderNumber: null,
        debtorName: null,
        workorderDescription: null,
        projectManagerIdentifier: null
    };
    const [defaultFilterValues, setDefaultFilterValues] = useState(defaultQuotationFilterValues);
    const { Quotations, QuotationsRequest } = useAppSelector((state) => state.quotation);
    const [searchQuotationText, setSearchQuotationText] = useState('');
    const handleButtonClick = () => {
        setIsOpen(true);
        navigate(`/admin/QuotationTabs`);
    };
    useEffect(() => {
        dispatch(getAllQuotationsAsync(defaultFilterValues));
        dispatch(getAllQuotationStatusAsync());
    }, []);
    const onRowClick = (rowId) => {
        window.open(`/admin/QuotationTabs/${rowId}`, '_blank');
    };
    const updateFilterValues = (newValues) => {
        setDefaultFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function onQuotationsPageChange(pageNumber) {
        updateFilterValues({ pageNumber });
        dispatch(getAllQuotationsAsync({
            ...defaultFilterValues,
            pageNumber // Override the pageNumber with the updated value
        }));
    }
    function searchQuotationHandler(searchText) {
        updateFilterValues({ filter: searchText });
        dispatch(getAllQuotationsAsync({
            ...defaultFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function SortingHanlder(data) {
        updateFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllQuotationsAsync({
            ...defaultFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection // Override the sortColumnKey and sortDirection with the updated values
        }));
    }
    function FilteringHandler(data) {
        data.pageNumber = 1;
        updateFilterValues(data);
        dispatch(getAllQuotationsAsync({
            ...defaultFilterValues,
            ...data // Override all filter properties with the updated values
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "Offertes" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Offerte', onClick: handleButtonClick, isDisabled: !handleRolePermission(Permission.OFFERTE, PermissionType.Create) }) })] }), _jsx("div", { className: 'mt-0', children: _jsxs(_Fragment, { children: [_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: searchQuotation, onSearch: searchQuotationHandler }), _jsx(QuotationsTable, { quotations: Quotations?.items, onRowClick: onRowClick, onSorting: SortingHanlder, onFilter: FilteringHandler })] }), _jsx("div", { className: 'mt-3', children: Quotations && (_jsx(VnPagination, { currentPage: Quotations?.pageNumber, totalPages: Quotations?.totalPages, onPageChange: onQuotationsPageChange })) })] }) }), _jsx(ModalPopup, { title: 'Nieuwe Offerte', content: _jsx(AddQuotationForm, { onClose: () => setIsOpen(false) }), onOpen: isOpen, onClose: () => setIsOpen(false), modalWidth: 'lg' })] }));
}
